// app/frontend/utils/metaPixel.ts
import META, {
  type EventData,
  type EventMetaData,
  type MetaPixelConfig,
  type StandardEvent,
} from '@adkit.so/meta-pixel';

const META_PIXEL_ID = '912865331663002';

let initialized = false;
const isDev = import.meta.env.DEV;

export const initMetaPixel = (config?: Partial<MetaPixelConfig>) => {
  if (initialized) return;

  const baseConfig: MetaPixelConfig = {
    pixelIds: META_PIXEL_ID,
    autoTrackPageView: false,
    enableLocalhost: isDev,
    debug: isDev,
  };

  META.init({ ...baseConfig, ...config });
  initialized = true;
};

export const trackMetaPageView = () => {
  if (!initialized) return;
  META.track('PageView');
};

export const trackMetaEvent = (
  event: StandardEvent,
  data?: EventData,
  meta?: EventMetaData,
) => {
  if (!initialized) return;
  META.track(event, data, meta);
};

export const trackMetaCustomEvent = (
  event: string,
  data?: EventData,
  meta?: EventMetaData,
) => {
  if (!initialized) return;
  META.trackCustom(event, data, meta);
};